import {  Injectable                  } from '@angular/core';
import {  BehaviorSubject, Observable } from 'rxjs';

export interface UserInfo
{
  city            : number  | null;
  department      : number  | null;
  email           : string  | null;
  empleado        : number  | null;
  nombre_usuario  : string  | null;
  officeLocation  : number  | null;
  organo          : string  | null;
  rol             : string  | null;
  roles           : []      | null;
}


@Injectable({
  providedIn: 'root' 
})

export class UserService
{
  private _userInfo = new BehaviorSubject<UserInfo>(
    {
      city            : null,
      department      : null,
      email           : null,
      empleado        : null,
      nombre_usuario  : null,
      officeLocation  : null,
      organo          : null,
      rol             : null,
      roles           : null,
    }
  );
 
  public readonly userInfo$: Observable<UserInfo> = this._userInfo.asObservable();

  constructor() {}

  setUserInfo(parcial : Partial<UserInfo>)
  {
    const actual      = this._userInfo.value;
    const actualizado = { ...actual, ...parcial };

    // console.log("USUARIO: ", this._userInfo['_value']);

    this._userInfo.next(actualizado);
  }

  getUserInfo() : UserInfo { return this._userInfo.getValue(); }
}